// CTSK-525 — Settings > Documents: effect used to highlight the card you just
// came back from. Stored in this browser (localStorage), not in the server envelope.
import { useState } from 'react';
import { HIGHLIGHT_EFFECTS, HOVER_ZOOMS, loadHighlightEffect, loadHoverZoom, saveHighlightEffect, saveHoverZoom, type HighlightEffect, type HoverZoom } from './viewPrefs.js';

const LABELS: Record<HighlightEffect, string> = {
  off: 'Off',
  shimmer: 'Shimmer',
  smoke: 'Smoke shadow',
  pulse: 'Rotating pulse',
};

const ZOOM_LABELS: Record<HoverZoom, string> = { current: 'Current size (no enlargement)', m: 'M (+6%)', l: 'L (+14%)' };

export function CardEffectField() {
  const [zoom, setZoom] = useState<HoverZoom>(() => loadHoverZoom());
  const [v, setV] = useState<HighlightEffect>(() => loadHighlightEffect());
  return (
    <>
    <label style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 16 }}>
      <span style={{ fontWeight: 600 }}>Card enlargement on hover (this browser)</span>
      <select
        aria-label="Card enlargement on hover"
        value={zoom}
        onChange={(e) => { const n = e.target.value as HoverZoom; setZoom(n); saveHoverZoom(n); }}
        style={{ padding: '6px 10px', border: '1px solid var(--border-strong)', borderRadius: 6, maxWidth: 260 }}
      >
        {HOVER_ZOOMS.map((z) => <option key={z} value={z}>{ZOOM_LABELS[z]}</option>)}
      </select>
    </label>
    <label style={{ display: 'flex', flexDirection: 'column', gap: 4, marginBottom: 16 }}>
      <span style={{ fontWeight: 600 }}>Card highlight on return (this browser)</span>
      <select
        value={v}
        onChange={(e) => { const n = e.target.value as HighlightEffect; setV(n); saveHighlightEffect(n); }}
        style={{ padding: '6px 10px', border: '1px solid var(--border-strong)', borderRadius: 6, maxWidth: 260 }}
      >
        {HIGHLIGHT_EFFECTS.map((e) => <option key={e} value={e}>{LABELS[e]}</option>)}
      </select>
      <span style={{ fontSize: 12, color: 'var(--text-muted)' }}>
        In Masonry / Grid, the document you just opened is highlighted when you come back to the list.
      </span>
    </label>
    </>
  );
}
